<!--
 * @Author: WeijianXu weijian.xu@unidt.com
 * @Date: 2024-04-10 15:24:38
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-04-10 17:24:15
 * @FilePath: \intelligent-knowledge-qa-pcd:\app\reps\ai-qa\assistant_portal_web\src\components\frame\DialogCertificate.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-dialog :model-value="visible" destroy-on-close width="400px" :before-close="handleClose"
    class="resource_dialog" :close-on-click-modal="false" :title="'企业认证'">
    <el-form ref="form" :model="formData" :rules="formRules" class="form" label-position="top"
      @submit.prevent="submitForm('form')">
      <el-form-item label="企业名称" prop="ename">
        <el-input v-model="formData.ename" maxlength="50" autocomplete="off" placeholder="请输入"
          size="large" />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" :loading="formLoading" @click="submitForm(form)">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { reactive, ref } from 'vue';
import { certificatePersonel } from '@/data/ApiPersonnel';
import { ElMessage } from 'element-plus';
import storeAccount from '@/config/storeAccount.js';
import userStore from '@/config/store-euser.js';
// import { useRouter } from 'vue-router';
export default {
  props: {
    visible: {
      type: Boolean,
      default: () => false,
    }
  },
  emits: ['update:visible'],
  setup(props, ctx) {
    const form = ref();
    const formLoading = ref(false);
    const account = storeAccount();
    const euser = userStore();
    // const router = useRouter()
    let formData = ref({
      phid: account.info.phid,
      ename: euser.eUserInfo.ename || undefined,
    });

    const formRules = reactive({
      ename: [{ required: true, message: '请输入待认证的企业名称', trigger: 'blur' }],
    });

    //表单操作
    const handleClose = () => {
      ctx.emit('update:visible', false);
    };
    const submitForm = form => {
      form.validate(valid => {
        if (valid) {
          certificatePersonel({
            ...formData.value,
          })
            .then(res => {
              ElMessage.success('认证成功');
              handleClose();
              account.GetUserInfo();
              euser.hasEName = true;
            })
            .finally(() => {
              formLoading.value = false;
            });
        } else {
          return false;
        }
      });
    };
    return {
      form,
      formRules,
      formData,
      formLoading,
      handleClose,
      submitForm,
    };
  },
};
</script>
<style lang="scss" scoped></style>
